// Mock data for the portfolio
export const mockProjects = [
  {
    id: 1,
    title: 'Ai-TalentSuite',
    description: 'An online Resume Analyser and mock interviewer using AI technology to help candidates improve their job prospects.',
    category: 'Website',
    technologies: ['React', 'Node.js', 'AI/ML', 'MongoDB'],
    liveDemo: 'https://talent-suite.vercel.app/',
    sourceCode: 'https://github.com/nishan/ai-talentsuite',
    image: 'https://s3.wns.com/S3_6/Images/Blog/DesktopImage/20358/15/AI-Talent-in-Procurement-Transformation-desktop.jpg',
    status: 'completed'
  },
  {
    id: 2,
    title: 'Agri-Claim',
    description: 'An online insurance claiming platform for farmers to easily file and track their agricultural insurance claims.',
    category: 'Website',
    technologies: ['React', 'Express.js', 'MySQL', 'Bootstrap'],
    liveDemo: ' ',
    sourceCode: 'https://github.com/Nishankulal03/Agri-Claim.git',
    image: 'https://images.unsplash.com/photo-1501004318641-b39e6451bec6?w=800&h=500&fit=crop',
    status: 'completed'
  },
  {
    id: 3,
    title: 'BookStore',
    description: 'A fully functional e-commerce website for books with shopping cart, payment integration, and user management.',
    category: 'Website',
    technologies: ['react', 'CSS', 'node.js', 'MongoDb', 'express'],
    liveDemo: null,
    sourceCode: '',
    image: 'https://blog.kotobee.com/wp-content/uploads/2023/11/library-Blog-Size.jpg',
    status: 'completed'
  },
  {
    id: 4,
    title: 'Disney-Clone',
    description: 'A pixel-perfect clone of Disney+ streaming platform UI/UX with responsive design and modern features.',
    category: 'Website',
    technologies: ['React', 'CSS3', 'JavaScript'],
    liveDemo: 'https://disney-clone-coral-two.vercel.app/',
    sourceCode: 'https://github.com/nishan/disney-clone',
    image: 'https://stastic.ui4free.com/public/images/figma-disney-plus-clone-template_1643156222.jpg',
    status: 'completed'
  }, {
    id: 5,
    title: 'API-Testing',
    description: 'Automated API testing framework built for comprehensive testing of RESTful APIs with detailed reporting.',
    category: 'Application',
    technologies: ['Python', 'Pytest', 'Requests', 'JSON'],
    liveDemo: null,
    sourceCode: 'https://github.com/Nishankulal03/API-Testing.git',
    image: 'https://www.xenonstack.com/hs-fs/hubfs/xenonstack-api-testing-tools.png?width=1280&height=720&name=xenonstack-api-testing-tools.png',
    status: 'completed'
  },
  {
    id: 6,
    title: 'Disk-Management',
    description: 'Automated disk cleanup tool that helps optimize system performance by removing unnecessary files and managing storage.',
    category: 'Application',
    technologies: [ 'Ui-Path', 'Automation'],
    liveDemo: null,
    sourceCode: null,
    image: 'https://files.codingninjas.in/article_images/custom-upload-1685026094-e94d7116.webp?w=500&h=400&fit=crop',
    status: 'completed'
  },
  {
    id: 7,
    title: 'Smart client Response',
    description: 'AI Email Response Generator with Feedback System',
    category: 'Website',
    technologies: ['Python', 'Openai API', 'Automation', 'GUI'],
    liveDemo: null,
    sourceCode: 'https://github.com/Nishankulal03/Nishan_SmartClientResponse_CanaraEngineeringCollege.git',
    image: 'https://www.streebo.com/wp-content/themes/streebo/images/Email-ChatGPT/img3.png',
    status: 'completed'
  },
    
];

export const mockContactInfo = {
  email: 'nishankulal424@gmail.com',
  
  location: 'Mangalore, India',
  social: {
    github: 'https://github.com/Nishankulal03',
    linkedin: 'https://www.linkedin.com/in/nishan-kulal-1877b4228/',
    twitter: 'https://x.com/nishan_kul84063?t=nJCGpUri8XLIsTs1kC3htA&s=09'
  }
};

export const mockStats = {
  projectsCompleted: 15,
  yearsOfExperience: 2,
  technologiesLearned: 14,
  certificationsEarned: 3
};